import { render, staticRenderFns } from "./sendToServiceNow.vue?vue&type=template&id=d882ac0e&scoped=true"
import script from "./sendToServiceNow.vue?vue&type=script&lang=js"
export * from "./sendToServiceNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882ac0e",
  null
  
)

export default component.exports